const TableHeader = ({ column }: any) => {
  let className = ''
  if (column.isSorted) className += column.isSortedDesc ? 'sorted-desc' : 'sorted-asc'

  className += column.align ? column.align : ''

  return (
    <th {...column.getHeaderProps(column.getSortByToggleProps())} className={className}>
      {column.render('Header')}
      <span />
    </th>
  )
}

export { TableHeader }
